import HomeContainer from "../../HomeContainer/HomeContainer";
import "./PromotionalBannersSkeleton.css";

export default function PromotionalBannersSkeleton({
  count = 2,
  columns = 2,
  container = true,
  className = "",
}) {
  const content = (
    <section
      className={`home-banners promotional-banners-skeleton ${className}`}
    >
      <div
        className={`home-banners__grid home-banners__grid--${columns}`}
      >
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className="promotional-banner-skeleton"
          >
            <div className="promotional-banner-skeleton__image" />
          </div>
        ))}
      </div>
    </section>
  );

  if (!container) {
    return content;
  }

  return <HomeContainer>{content}</HomeContainer>;
}